import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Endpoints } from '../../apis';
import { getErrorMessage } from '@xver/utils/error';

export function useToggleBaremetalAutoRenewMutate() {
    const { t } = useTranslation('notifications');
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id: number) => Endpoints.v1.Baremetals.permuteAutoRenew(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['api.v1.baremetals.list'] });
            queryClient.invalidateQueries({ queryKey: ['api.v1.baremetals.get'] });
            notifications.show({
                title: t('baremetal.autoRenewUpdatedTitle'),
                message: t('baremetal.autoRenewUpdatedMessage'),
                icon: <IconCheck size={32} color={'#00ff00'} />,
            });
        },
        onError: (error: any) => {
            notifications.show({
                title: t('baremetal.autoRenewFailedTitle'),
                message: getErrorMessage(error),
                icon: <IconExclamationCircle size={32} color={'#eb5757'} />,
            });
        },
    });
}
